// Vendors
import styled, { css } from 'styled-components';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const GAP_VERTICAL = 230;

const getHeightStyles = ({ height, frameGap }: { height?: number; frameGap?: number }) =>
  height
    ? css`
        height: ${height}px;
      `
    : css`
        height: calc(100vh - ${convertPxsToRems({ pixels: frameGap ?? GAP_VERTICAL, base: 16 })});
      `;

const IframeCommonComponentStyled = css<{ frameGap: number; height?: number }>`
  width: 100%;
  ${props => getHeightStyles({ height: props.height, frameGap: GAP_VERTICAL })};

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    ${props => getHeightStyles({ height: props.height, frameGap: props.frameGap })}
  }
`;

const IframeComponentStyled = styled.iframe<{
  fetching: boolean;
  frameGap: number;
  height?: number;
}>`
  border: none;
  width: 0;
  ${({ fetching }) => !fetching && IframeCommonComponentStyled};
`;
IframeComponentStyled.displayName = 'IframeComponentStyled';

const IframeLoadingComponentStyled = styled.div<{ fetching: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center;
  ${({ fetching }: any) => fetching && IframeCommonComponentStyled};
`;
IframeLoadingComponentStyled.displayName = 'IframeLoadingComponentStyled';

const IframeLoaderComponentStyled = styled.div<{ fetching: boolean }>`
  ${({ fetching, theme }) => fetching && `padding: ${theme.spacing_300};`}
`;
IframeLoaderComponentStyled.displayName = 'IframeLoaderComponentStyled';

export { IframeComponentStyled, IframeLoadingComponentStyled, IframeLoaderComponentStyled };
